import { EventHubExperience } from '../../../../Api'
import { ExperienceItem } from './ExperienceItem'
import { ExperiencesCon } from '../styles'

type ExperiencesParams = {
  experiences: EventHubExperience[]
  handleExperienceSelected: (experience: EventHubExperience) => void
}

export const Experiences: React.FC<ExperiencesParams> = ({
  experiences,
  handleExperienceSelected,
}) => {
  return (
    <ExperiencesCon>
      {experiences.map((experience, index) => (
        <ExperienceItem
          key={experience.title}
          experience={experience}
          onExperienceSelected={handleExperienceSelected}
          index={index}
        />
      ))}
    </ExperiencesCon>
  )
}
